import datepicker from 'jquery-ui/ui/widgets/datepicker';

$(function () {
  // Datepickers
  $(".js-minerva-form-datepicker").each(function () {
    $(this).find('input').datepicker($.parseJSON($(this).find('script[type="application/json"]').text()));
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/datepicker.js